module.exports = __webpack_public_path__ + "86ed8dbb1057260d4a2d84f28fd38950.png";